import { DocumentNode, gql } from '@apollo/client'

export const GET_FAMILY_CONSENT_REQUESTS: DocumentNode = gql`
    query GetFamilyConsentRequests($daycareId: Int!) {
        getFamilyConsentRequests(daycareId: $daycareId) {
            id
            parentName
            requestingDaycareName
            createdAt
            votes {
                id
                daycareName
                decision
            }
        }
    }
`

export const GET_OUTGOING_CONSENT_REQUESTS: DocumentNode = gql`
    query GetOutgoingConsentRequests($daycareId: Int!) {
        getOutgoingConsentRequests(daycareId: $daycareId) {
            id
            parentName
            requestingDaycareName
            createdAt
            votes {
                id
                daycareName
                decision
            }
        }
    }
`

export const RESPOND_TO_CONSENT_REQUEST: DocumentNode = gql`
    mutation RespondToConsentRequest($daycareId: Int!, $consentRequestId: Int!, $decision: ConsentVoteDecision!) {
        respondToConsentRequest(daycareId: $daycareId, consentRequestId: $consentRequestId, decision: $decision)
    }
`
